module.exports = __webpack_public_path__ + "img/studycommentylActive.2c9f706a.svg";